/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import { defaultAddClientData, AddClientData } from './IAppModels'
import { StepperComponent } from '../../../assets/ts/components'
import { KTSVG } from '../../../helpers'
import { Step1 } from './steps/Step1'
import { Step3 } from './steps/Step3'
import { Step4 } from './steps/Step4'
import crossSymbol from '../../../images/closeSymbol.svg'
import Arrow from '../../../images/arr002.svg'
import SVG from 'react-inlinesvg'
import { useMutation } from '@apollo/client'
import { CREATECLIENT } from '../../../../utils/GraphQLAPI'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Step6 } from './steps/Step6'
import { Step5 } from './steps/Step5'
import { Step7 } from './steps/Step7'
const MySwal = withReactContent(Swal)

const style = { positionStyle: 'relative' }
const defaultDialInNumber = [{ dialInNumber: '', position: 0, dialInNoError: '' }]

const modalsRoot = document.getElementById('root-modals') || document.body

const CreateAppModal = ({
  show,
  add,
  data1,
  handleClose,
  getTpvAdminClientList,
  refreshList,
}: any) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [data, setData] = useState<AddClientData>(defaultAddClientData)
  const [hasError, setHasError] = useState(false)
  const [brandsInfo, setBrandsInfo] = useState<any>(true)
  const [dialNumbersInfo, setDialNumbersInfo] = useState<any>([])
  const [isDisabled, setIsDisabled] = useState<boolean>(false)
  const [emailValidate, setEmailValidate] = useState<string>('')
  const [emailDisabled, setEmailDisabled] = useState<boolean>(false)
  const [dialInNoValidation, setDialInNoValidation] = useState<string>('')
  const [dialInNumber, setdialInNumber] = useState(defaultDialInNumber)
  const [deleteCall, setDeleteCall] = useState<boolean>(false)
  const [apiDialInData] = useState([])
  const [notes, setNotes] = useState([
    {
      description: '',
      position: 1,
    },
    {
      description: '',
      position: 2,
    },
    {
      description: '',
      position: 3,
    },
  ])
  // const [checkbrandInfo, setCheckbrandInfo] = useState<boolean>(false)

  useEffect(() => {
    setEmailDisabled(false)
    if (emailValidate && emailValidate === 'Email ID already exists!') {
      setEmailDisabled(true)
    } else if (dialInNoValidation && dialInNoValidation != '') {
      setEmailDisabled(true)
    }
  }, [emailValidate, dialInNoValidation])

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  useEffect(() => {
    setIsDisabled(false)
    setData(defaultAddClientData)
    // if(callClient){
    //   getTpvAdminClientList();
    // }
  }, [data1, add])

  const updateData = (fieldsToUpdate: Partial<AddClientData>) => {
    setData((prev: any) => ({ ...prev, ...fieldsToUpdate }))
  }

  // Validating the client-details
  const checkClientDetails = (): boolean => {
    const zipVal = /^(?!0{5})([0-9]{5}(?:-[0-9]{4})?|[A-Z][0-9][A-Z])$/
    if (
      !data.clientInfo.clientName ||
      !data.clientInfo?.clientAdmin?.clientEmail ||
      !data.clientInfo.clientAddress ||
      data.clientInfo.city === '' ||
      !data.clientInfo.state ||
      !data.clientInfo.zipcode ||
      !data.clientInfo.clientDuns
    ) {
      return false
    } else if (
      data.clientInfo.clientName.length > 40 &&
      /[^a-zA-Z0-9]/.test(data.clientInfo.clientName)
    ) {
      return false
    } else if (!data.clientInfo.zipcode.match(zipVal)) {
      return false
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.clientInfo?.clientAdmin?.clientEmail)
    ) {
      return false
    } else if (data.clientInfo.clientAddress.length > 130) {
      return false
    } else if (/[^0-9A-Za-z ,]/.test(data.clientInfo.city)) {
      return false
    }
    return true
  }

  const checkBrandEmailValidation = (addBrandList: any) => {
    if (addBrandList) {
      addBrandList &&
        addBrandList.map((brand: any) => {
          if (
            brand.brandEmailId !== '' &&
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(brand.brandEmailId)
          ) {
            setBrandsInfo(false)
            //throw sentinel;
          } else {
            setBrandsInfo(true)
          }
        })
    }
  }

  const checkbrandNameValidation = (addBrandList: any) => {
    if (addBrandList) {
      addBrandList &&
        addBrandList.map((brand: any) => {
          if (/[^a-zA-Z0-9_ ]/.test(brand.brandName)) {
            setBrandsInfo(false)
            //throw sentinel;
          } else if (brand.brandName.length > 20) {
            setBrandsInfo(false)
          } else {
            setBrandsInfo(true)
          }
        })
    }
  }

  const brandInfoUpdate = (data: boolean, addBrandList: any) => {
    const dataCheckVal: any = checkBrandEmailValidation(addBrandList)
    const brandNameCheckVal: any = checkbrandNameValidation(addBrandList)
    if (dataCheckVal && brandNameCheckVal) {
      setBrandsInfo(true)
    }
  }

  const checkpriceSetup = () => {
    const setupFees: any = data.pricingSetup.setupFees
    const monthlyFees: any = data.pricingSetup.monthlyFees
    const perTpv: any = data.pricingSetup.perTpv
    const perMin: any = data.pricingSetup.perMin
    const monthlyMin: any = data.pricingSetup.monthlyMin
    const lateChargeFees: any = data.pricingSetup.lateChargeFees
    const salesTax: any = data.pricingSetup.salesTax
    const stripeFees: any = data.pricingSetup.stripeFees
    const creditAmount: any = data.pricingSetup.creditAmount
    if (
      setupFees < 0 ||
      monthlyFees < 0 ||
      perTpv < 0 ||
      perMin < 0 ||
      monthlyMin < 0 ||
      lateChargeFees < 0 ||
      salesTax < 0 ||
      stripeFees < 0 ||
      creditAmount < 0
    ) {
      setHasError(true)
      return false
    } else {
      setHasError(false)
      return true
    }
  }


  const isValid =
    Array.isArray(brandsInfo) &&
    brandsInfo.every(
      (brand: any) =>
        Array.isArray(brand.brandAdmin) &&
        brand.brandAdmin.every((admin: any) => admin?.emailId === "")
    );

  const prevStep = () => {
    if (!stepper.current) {
      return
    }

    stepper.current.goPrev()
    setEmailDisabled(false)
  }
  useEffect(() => {

    if (stepper?.current?.getCurrentStepIndex() === 2) {
      if (!brandsInfo || isValid) {
        setEmailDisabled(true)
        setHasError(true)
        return
      } else {
        setHasError(false)
      }
    }

  }, [stepper?.current?.getCurrentStepIndex(), isValid])
  const nextStep = () => {
    // setHasError(false)
    if (!stepper.current) {
      return
    }

    if (stepper.current.getCurrentStepIndex() === 1) {
      if (!checkClientDetails()) {
        setHasError(true)
        return
      } else {
        setHasError(false)
      }
    }

    if (stepper.current.getCurrentStepIndex() === 2) {
      if (!brandsInfo || isValid) {
        setEmailDisabled(true)
        setHasError(true)
        return
      } else {
        setHasError(false)
      }
    }

    if (stepper.current.getCurrentStepIndex() === 3) {
      if (!checkpriceSetup()) {
        setHasError(true)
        return
      }
      // else {
      //   setHasError(false)
      // }
    }
    stepper.current.goNext()
  }
  // graphql query for create client
  const [createClient] = useMutation(CREATECLIENT, {
    variables: {
      createClientInput: {
        name: data.clientInfo.clientName,
        logoUrl: data.clientInfo.imageUrl,
        clientAdmin: {
          emailId: data.clientInfo?.clientAdmin?.clientEmail,
        },
        address: data.clientInfo.clientAddress,
        zipCode: data.clientInfo.zipcode,
        brands: brandsInfo,
        clientDialInNumbers: dialNumbersInfo,
        city: data.clientInfo.city,
        country: data.clientInfo.country,
        state: data.clientInfo.state,
        clientDunsNumber: data.clientInfo.clientDuns,
        isEdiRecordingSyncRequired: data.clientInfo.EDIRecordingSync,
        isEdiEnrollmentRequired: data.clientInfo.isEdiEnrollmentRequired,
        isCopyUan: data.clientInfo.isCopyUan,
        creditType: data.pricingSetup.creditType,
        creditAmount: Number(data.pricingSetup.creditAmount),
        lateChargeFees: Number(data.pricingSetup.lateChargeFees),
        monthlyFees: Number(data.pricingSetup.monthlyFees),
        monthlyMinimums: Number(data.pricingSetup.monthlyMin),
        salesTax: Number(data.pricingSetup.salesTax),
        setupFees: Number(data.pricingSetup.setupFees),
        stripeFees: Number(data.pricingSetup.stripeFees),
        perMin: Number(data.pricingSetup.perMin),
        perTpv: Number(data.pricingSetup.perTpv),
        isActive: true,
        clientNotes: notes,
        notes: data.notesInfo.inputText,
        isGoogleSearchAheadRequired: data.clientSettings.googleSearch,
        isTranscribedResponseRequired: data.clientSettings.transcribedResponse,
        isSmartDocEnabled: data.clientSettings.isSmartDocEnabled,
        enableWelcomeScriptFlow: data.clientSettings.enableWelcomeScriptFlow,
        isDncScrubbingEnabled:data.clientSettings.isDncScrubbingEnabled,
        isBillImagesRequired: data.clientSettings.billImages,
        enableLiveAgent: data.clientSettings.liveAgents,
        enableCustomerDetails: data.clientSettings.liveAgentCustomerDetailsEditable,
        ClientLiveAgentNumber: [data.liveAgentNumberEnglish, data.liveAgentNumberSpanish],
        enableTextTpv: data.clientSettings.smsTPV,
        enableEmailDocumentVerification: data.clientSettings.emailD2D,
        enableSmsDocumentVerification: data.clientSettings.smsD2D,
        clientOptInMessage: Boolean(data.optInMessage) ? data.optInMessage : null,
        enableOutBoundLiveAgent: data.clientSettings.outboundLiveAgent,
        enableApiCheck: data.clientSettings.enableApiCheck,
        enableNoTPV: data.clientSettings.enableNoTPV,
        clientOutBoundNumbers: [
          data?.outboundLiveAgentDialInNumberEng,
          data?.outboundLiveAgentDialInNumberSpn,
        ],
        clientOutBoundMessage: data?.outboundLiveAgentFailMsg,
        enableDynamicProductCreation: data.clientSettings.enableDynamicProductCreation,
        enableContractStartDate: data.clientSettings.enableContractStartDate,
        isUtilityMeterNumberRequired: data.clientSettings.isUtilityMeterNumberRequired,
        billUploadOnlyByCamera: data.clientSettings.billUploadOnlyByCamera,
        disableExistingCustomerEnrollment: data.clientSettings.disableExistingCustomerEnrollment,
        enableKaptureCrm: data.clientSettings.enableKaptureCrm,
        enableZipCodeInUtility: data.clientSettings.enableZipCodeInUtility,
        enableCustomerReportToSalesChannel: data.clientSettings.enableCustomerReportToSalesChannel,
        enableLineTypeIntelligence: data.clientSettings.enableLineTypeIntelligence,
        enableMultipleUan: data.clientSettings.enableMultipleUan
      },
    },
    onCompleted: (data) => {
      if (data.createClient.id) {
        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
          },
          title: 'Client created successfully',
          icon: 'success',
        }
        MySwal.fire(options)
      }
      refreshList()
      setData(defaultAddClientData)
    },
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
    },
  })
  const validateBrandAdmin = (brandAdmindata: any) => {
    let valid = false
    brandAdmindata.forEach((element: any) => {
      valid = Object.values(element).some((v: any) => v)
    })
    return valid
  }

  const validateDialInNumber = (brandAdmindata: any[]) => {
    let valid = false

    brandAdmindata.forEach((element: any) => {
      valid = Object.values(element).some((v: any) => v)
    })
    return valid
  }

  const submit = async (e: any) => {
    if (data?.clientInfo?.dialInNumber) {
      const values = [...dialInNumber]

      const isEmptyObj = (obj: {
        dialInNumber: string
        position?: number
        dialInNoError?: string
      }) => {
        return Object.values(obj.dialInNumber).every(
          (val) => val === '' || val === null || val === undefined
        )
      }

      const index = data?.clientInfo?.dialInNumber?.findIndex((obj) => isEmptyObj(obj))

      if (index > -1) {
        values[index]['dialInNoError'] = 'Dial In Number is required'
        setHasError(true)
        return
      }
    }

    if (
      data?.clientSettings.liveAgents &&
      (Object.values(data?.liveAgentNumberEnglish).includes('') ||
        Object.values(data?.liveAgentNumberSpanish).includes('') ||
        data?.liveAgentNumberEnglish?.liveAgentDialInNumber?.length !== 10 ||
        data?.liveAgentNumberSpanish?.liveAgentDialInNumber?.length !== 10)
    ) {
      setHasError(true)
      return
    }

    const filterBrandsInfo = (data: any) => {
      return data.filter((brand: any) => {
        // Remove the brand if it has isDelete set to true and no id
        if (brand.isDelete && !brand.hasOwnProperty('id')) {
          return false
        }

        // Filter the brandAdmin array
        brand.brandAdmin = brand.brandAdmin.filter((admin: any) => {
          // Remove brandAdmin if it has isDelete set to true and no id
          return !(admin.isDelete && !admin.hasOwnProperty('id')) && admin.emailId !== ''
        })

        // Remove brand if it has no brandAdmin left after filtering
        return brand.brandAdmin.length > 0
      })
    }

    const filteredBrandsInfo = filterBrandsInfo(brandsInfo)
    setBrandsInfo(filteredBrandsInfo)

    const dialNumbers: any = []
    if (
      data.clientInfo.dialInNumber.length >= 1 &&
      validateDialInNumber(data.clientInfo.dialInNumber)
    ) {
      for (let index = 0; index < data.clientInfo.dialInNumber.length; index++) {
        const number_json: any = {}
        if (data.clientInfo.dialInNumber[index].dialInNumber !== '') {
          number_json.dialInNumber = data.clientInfo.dialInNumber[index].dialInNumber
          number_json.position = data.clientInfo.dialInNumber[index].position
          dialNumbers.push(number_json)
        }
      }
      await setDialNumbersInfo(dialNumbers)
    } else {
      setDialNumbersInfo([])
    }
    createClient()
    handleDataAfterClose()
  }

  const handleDataAfterClose = () => {
    handleClose()
    setData(defaultAddClientData)
    setdialInNumber(defaultDialInNumber)
    setHasError(false)
    setEmailValidate('')
    setEmailDisabled(false)
  }
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-fullscreen'
      show={show}
      onHide={handleDataAfterClose}
      onEntered={loadStepper}
      backdrop={true}
      className='custom-border w-880px'
    >
      <div className='modal-content' style={{ borderRadius: '14px' }}>
        <div className='modal-header' style={{ height: '80px' }}>
          <h2>{add} Client</h2>
          {/* begin::Close */}
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={handleDataAfterClose}
          >
            <img src={crossSymbol} alt='close' />
          </div>
          {/* end::Close */}
        </div>

        <div className='modal-body py-lg-10 px-lg-10'>
          {/*begin::Stepper */}
          <div
            ref={stepperRef}
            className='stepper stepper-pills stepper-column d-flex flex-xs-column flex-row flex-xl-row flex-row-fluid'
            id='kt_modal_create_app_stepper'
          >
            {/* begin::Aside*/}
            <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-300px w-xl-300px'>
              {/* begin::Nav*/}
              <div className='stepper-nav ps-lg-10 justify-content-sm-between'>
                {/* begin::Step 1*/}
                <div className='stepper-item current' data-kt-stepper-element='nav'>
                  {/* begin::Wrapper*/}
                  <div className='stepper-wrapper w-30'>
                    {/* begin::Icon*/}
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>1</span>
                    </div>
                    {/* end::Icon*/}

                    {/* begin::Label*/}
                    <div className='stepper-label'>
                      <span
                        className='stepper-title fw-500'
                        style={{
                          color: '#5E6278',
                          fontSize: '15px',
                          fontStyle: 'normal',
                          lineHeight: '24px',
                        }}
                      >
                        Client Info
                      </span>

                      <div
                        className='stepper-desc text-muted'
                        style={{ fontSize: '12px', lineHeight: '18px' }}
                      >
                        Provide client information
                      </div>
                    </div>
                    {/* end::Label*/}
                  </div>
                  {/* end::Wrapper*/}

                  {/* begin::Line*/}
                  <div className='stepper-line'></div>
                  {/* end::Line*/}
                </div>
                {/* end::Step 1*/}

                {/* begin::Step 2*/}
                <div className='stepper-item' data-kt-stepper-element='nav'>
                  {/* begin::Wrapper*/}
                  <div className='stepper-wrapper'>
                    {/* begin::Icon*/}
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>2</span>
                    </div>
                    {/* begin::Icon*/}

                    {/* begin::Label*/}
                    <div className='stepper-label'>
                      <span
                        className='stepper-title fw-500'
                        style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                      >
                        System Admin Info
                      </span>

                      <div
                        className='stepper-desc text-muted'
                        style={{ fontSize: '12px', lineHeight: '18px' }}
                      >
                        Add system admin info
                      </div>
                    </div>
                    {/* begin::Label*/}
                  </div>
                  {/* end::Wrapper*/}

                  {/* begin::Line*/}
                  <div className='stepper-line h-40px'></div>
                  {/* end::Line*/}
                </div>
                {/* end::Step 2*/}

                {/* begin::Step 3*/}
                <div className='stepper-item' data-kt-stepper-element='nav'>
                  {/* begin::Wrapper*/}
                  <div className='stepper-wrapper'>
                    {/* begin::Icon*/}
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>3</span>
                    </div>
                    {/* end::Icon*/}

                    {/* begin::Label*/}
                    <div className='stepper-label'>
                      <span
                        className='stepper-title fw-500'
                        style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                      >
                        Pricing Setup
                      </span>

                      <div
                        className='stepper-desc text-muted'
                        style={{ fontSize: '12px', lineHeight: '18px' }}
                      >
                        Provide pricing details
                      </div>
                    </div>
                    {/* end::Label*/}
                  </div>
                  {/* end::Wrapper*/}

                  {/* begin::Line*/}
                  <div className='stepper-line h-40px'></div>
                  {/* end::Line*/}
                </div>
                {/* end::Step 3*/}

                {/* begin::Step 4*/}
                <div className='stepper-item' data-kt-stepper-element='nav'>
                  {/* begin::Wrapper*/}
                  <div className='stepper-wrapper'>
                    {/* begin::Icon*/}
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>4</span>
                    </div>
                    {/* end::Icon*/}

                    {/* begin::Label*/}
                    <div className='stepper-label'>
                      <span
                        className='stepper-title fw-500'
                        style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                      >
                        Notes
                      </span>

                      <div
                        className='stepper-desc text-muted'
                        style={{ fontSize: '12px', lineHeight: '18px' }}
                      >
                        Add notes for reference
                      </div>
                    </div>
                  </div>
                  <div className='stepper-line h-40px'></div>
                </div>
                <div className='stepper-item' data-kt-stepper-element='nav'>
                  {/* begin::Wrapper*/}
                  <div className='stepper-wrapper'>
                    {/* begin::Icon*/}
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>5</span>
                    </div>
                    {/* end::Icon*/}

                    {/* begin::Label*/}
                    <div className='stepper-label'>
                      <span
                        className='stepper-title fw-500'
                        style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                      >
                        Settings
                      </span>

                      <div
                        className='stepper-desc text-muted'
                        style={{ fontSize: '12px', lineHeight: '18px' }}
                      >
                        Enable/Disable features
                      </div>
                    </div>
                  </div>
                  <div className='stepper-line h-40px'></div>
                </div>
                <div className='stepper-item' data-kt-stepper-element='nav'>
                  <div className='stepper-wrapper'>
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>6</span>
                    </div>

                    <div className='stepper-label'>
                      <span
                        className='stepper-title fw-500'
                        style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                      >
                        Dial In Numbers
                      </span>

                      <div
                        className='stepper-desc text-muted'
                        style={{ fontSize: '12px', lineHeight: '18px' }}
                      >
                        Add dial in numbers for TPV
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='flex-row-fluid px-lg-8 w-500px'>
              <form noValidate id='kt_modal_create_app_form'>
                <Step1
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                  setHasError={setHasError}
                  isDisabled={isDisabled}
                  emailValidate={emailValidate}
                  setEmailValidate={setEmailValidate}
                  style={style}
                  setNotes={setNotes}
                  notes={notes}
                  setDeleteCall={setDeleteCall}
                  deleteCall={deleteCall}
                />
                <Step7
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                  setHasError={setHasError}
                  isDisabled={isDisabled}
                  style={style}
                  callBack={brandInfoUpdate}
                  setBrandsInfo={setBrandsInfo}
                  setEmailDisabled={setEmailDisabled}
                />
                <Step3
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                  setHasError={setHasError}
                  isDisabled={isDisabled}
                  style={style}
                />
                <Step4
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                  setHasError={setHasError}
                  isDisabled={isDisabled}
                  style={style}
                />
                <Step6 data={data} updateData={updateData} />
                <Step5
                  data={data}
                  updateData={updateData}
                  setDialInNoValidation={setDialInNoValidation}
                  dialInNoValidation={dialInNoValidation}
                  setEmailDisabled={setEmailDisabled}
                  emailDisabled={emailDisabled}
                  setdialInNumber={setdialInNumber}
                  dialInNumber={dialInNumber}
                  apiDialInData={apiDialInData}
                  hasError={hasError}
                />

                {/*begin::Actions */}

                {/* Check */}

                <div className='d-flex flex-stack pt-10'>
                  <div className='me-2'>
                    <button
                      type='button'
                      className='btn btn-lg btn-light-primary me-3'
                      data-kt-stepper-action='previous'
                      onClick={prevStep}
                    >
                      <span className='me-1'>
                        <SVG src={Arrow} className='mh-50px' />
                      </span>
                      <span>Back</span>
                    </button>
                  </div>
                  <div>
                    <button
                      type='button'
                      className='btn btn-lg btn-primary'
                      data-kt-stepper-action='submit'
                      onClick={(e) => {
                        submit(e)
                      }}
                    >
                      {add === 'Add' ? 'Create Client' : 'Update Client'}
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-2 me-0'
                      />
                    </button>

                    <button
                      type='button'
                      className='btn btn-lg btn-primary'
                      data-kt-stepper-action='next'
                      onClick={nextStep}
                      disabled={emailDisabled}
                    >
                      Continue
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-1 me-0'
                      />
                    </button>
                  </div>
                </div>

                {/*end::Actions */}
              </form>
              {/*end::Form */}
            </div>
            {/*end::Content */}
          </div>
          {/* end::Stepper */}
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export { CreateAppModal }
